import { Injectable } from '@angular/core';
import { ContentfulClientApi, Entry } from 'contentful';
import { ContentfulClientService } from './contentful-client.service';

@Injectable({
  providedIn: 'root',
})
export class ContentfulService {
  private client: ContentfulClientApi;

  constructor(clientService: ContentfulClientService) {
    this.client = clientService.createClient();
  }

  public async getEntries<T>(contentType: string): Promise<Entry<T>[]> {
    try {
      const result = await this.client.getEntries<T>({
        content_type: contentType,
      });
      return result.items;
    } catch (error) {
      console.error(`Failed to get entries of type '${contentType}'`, error);
      throw error;
    }
  }
}
